import EventEmitter from "base/EventEmitter";
import FormValidator from "base/FormValidator";
import Ajax from "base/Ajax";
import { svg_include } from "base/functions";

export default class ConsultantSearch extends EventEmitter {
    constructor($element) {
        super();
        this.$element = $element;
        this.$form = this.$element.find('.js-consultants-search');
        this.$content = this.$element.find('.js-results');
        this.type = this.$element.attr('data-consultant-type');

        this.filters = {};
        this.request = null;
        this.page = 1;

        this.form = new FormValidator(this.$form);
        this.bindEvents();
    }

    bindEvents() {
        let me = this;

        this.$form.on('change', '.js-select', () => {
            this.form.submit();
        });

        this.$element.on('click', '.js-change-page', function () {
            me.filters.page = $(this).attr('data-page');
            me.getResults();
            return false;
        }).on('click', '.js-show-all', () => {
            me.filters.showAll = true;
            me.getResults();
            return false;
        }).on('click', '.js-mobile-open', () => {
            console.log('here');
            this.$element.find('.js-mobile-modal').addClass('mobile-modal--active');
            $('body').addClass('mobile-modal-active');
        }).on('click', '.js-mobile-close', () => {
            this.$element.find('.js-mobile-modal').removeClass('mobile-modal--active');
            $('body').removeClass('mobile-modal-active');
        });

        this.form.on("submit", ($form) => {
            this.filters = $form.serializeJSON();
            this.filters.page = 1;
            this.getResults();
        });
    }

    getResults() {

        this.$content.addClass('loading');

        if (this.request !== null) {
            this.request.abort();
        }

        console.log(this.type);

        if(this.type === 'rehab-clinic'){
            this.request = Ajax.get('eotw-rehab-consultants', 'consultants', this.filters);
        } else {
            this.request = Ajax.get('eotw-consultants', 'consultants', this.filters);
        }

        this.request.then((data) => {
            this.request = null;
            this.$content.html(data.data.html);
            this.$content.removeClass('loading');
            this.scrollToTop();
        }).catch((e) => {
            this.request = null;
            console.trace(e);
            this.$content.removeClass('loading');
            this.$content.html(eotwJSXFactory('div', {className: "message message--error"}, [eotwJSXFactory('span', {className: "icon", unsafeHtml: svg_include('error')}),"An unexpected error has occurred"]));
            this.scrollToTop();
        });
    }

    scrollToTop() {
        $('html, body').animate({
            scrollTop: this.$element.offset().top - 50
        }, 500);
    }
}
